import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19ecb4b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "w-full h-full flex justify-center items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "h-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueApexCharts = _resolveComponent("VueApexCharts")!

  return (!_ctx.solvedProblemsPresenter.hasData.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t('message.noData')), 1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_VueApexCharts, {
          height: "100%",
          options: _ctx.solvedProblemsPresenter.chartOptions.value,
          series: _ctx.solvedProblemsPresenter.chartSeries.value,
          type: "area"
        }, null, 8, ["options", "series"])
      ]))
}